import React, { useRef, useEffect, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

/* ============================================================
   🔥 PRODUCTS LIST
============================================================ */
const products = [
  { id: "coltcs", title: "Condenser Online Tube Cleaning System (COLTCS)", img: "/Web4.jpg" },
  { id: "debris-filters", title: "Debris & Automatic Filters", img: "/Web5.jpg" },
  { id: "sponge-balls", title: "Sponge Rubber Balls", img: "/spb.jpg" },
  { id: "strainers", title: "Low-Pressure Drop Strainers", img: "/Strainer.png" },
  { id: "pipeline-division", title: "Pipeline Division", img: "/Web-7.jpg" },
  { id: "pressure-vessels", title: "Pressure Vessels", img: "/Pressure Vessel.JPG" },
  { id: "signalers", title: "Pig Signalers", img: "/Pig_signaller.png" },
  { id: "quick-opening", title: "Quick Opening Closure", img: "/quick closer.jpg" }
];

// Duplicate for infinite scrolling
const loop = [...products, ...products];

export default function Products3D() {
  const navigate = useNavigate();
  const track = useRef(null);
  const [isHover, setHover] = useState(false);

  useEffect(() => {
    const slider = track.current;

    const move = setInterval(() => {
      if (!isHover) {
        if (slider.scrollLeft >= slider.scrollWidth / 2) {
          slider.scrollLeft = 0;
        } else {
          slider.scrollBy({ left: 350, behavior: "smooth" });
        }
      }
    }, 2500);

    return () => clearInterval(move);
  }, [isHover]);

  const scrollLeft = () => {
    track.current.scrollBy({ left: -350, behavior: "smooth" });
  };

  const scrollRight = () => {
    track.current.scrollBy({ left: 350, behavior: "smooth" });
  };

  return (
    <Box
      id="products"
      sx={{
        py: 10,
        background: "#F7FAFF",
        px: { xs: 2, sm: 4, md: "250px" },
        fontFamily: "Roboto",
      }}
    >
      {/* ===================== HEADING ===================== */}
      <Box sx={{ textAlign: "center", mb: 6 }}>
        <Typography
          component="h1"                 // ✅ semantic
          sx={{
            fontSize: "32px",             // ✅ 32px
            fontWeight: 800,
            color: "#2d2075",
            letterSpacing: 0.8,
            lineHeight: 1.5,              // ✅ line-height
            mb: 1,
          }}
        >
          Products
        </Typography>

        <Box
          sx={{
            width: "90px",
            height: "3px",
            backgroundColor: "#2d2075",
            borderRadius: "2px",
            mx: "auto",
            mt: "-4px",
          }}
        />
      </Box>

      {/* ===================== SLIDER ===================== */}
      <Box
        sx={{ position: "relative" }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {/* LEFT ARROW */}
        <IconButton
          onClick={scrollLeft}
          aria-label="Scroll products left"
          sx={{
            position: "absolute",
            left: -50,
            top: "45%",
            zIndex: 10,
            display: { xs: "none", md: "flex" },
            background: "#fff",
            boxShadow: "0 4px 10px rgba(0,0,0,.15)",
            "&:hover": { background: "#2d2075", color: "#fff" },
          }}
        >
          <ArrowBackIosNewIcon />
        </IconButton>

        {/* TRACK */}
        <Box
          ref={track}
          sx={{
            display: "flex",
            gap: 3,
            overflowX: "auto",
            scrollBehavior: "smooth",
            pb: 2,
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          {loop.map((p, index) => (
            <Box
              key={index}
              role="article"               // ✅ semantic
              onClick={() => navigate(`/products/${p.id}`)}
              sx={{
                flex: "0 0 320px",
                background: "#fff",
                borderRadius: "2px",
                cursor: "pointer",
                overflow: "hidden",
                boxShadow: "0 4px 14px rgba(0,0,0,.1)",
                transition: ".3s",
                "&:hover": { transform: "translateY(-5px)" },
              }}
            >
              <img
                src={p.img}
                alt={p.title}
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  display: "block",
                }}
              />

              <Box p={2}>
                <Typography
                  component="h2"          // ✅ semantic sub-heading
                  sx={{
                    fontSize: "20px",      // ✅ 20px
                    fontWeight: 700,
                    color: "#2d2075",
                    lineHeight: 1.5,       // ✅ line-height
                    fontFamily: "Roboto",
                  }}
                >
                  {p.title}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>

        {/* RIGHT ARROW */}
        <IconButton
          onClick={scrollRight}
          aria-label="Scroll products right"
          sx={{
            position: "absolute",
            right: -50,
            top: "45%",
            zIndex: 10,
            display: { xs: "none", md: "flex" },
            background: "#fff",
            boxShadow: "0 4px 10px rgba(0,0,0,.15)",
            "&:hover": { background: "#2d2075", color: "#fff" },
          }}
        >
          <ArrowForwardIosIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
